<template>
  <div class="order-details" v-show="hasProductsInBasket && selectedTimeSlot">
    <h1>Kontaktuppgifter</h1>
    <form ref="form">
      <div class="inner">
        <fieldset>
          <input
            :class="hasData(name)"
            name="name"
            type="text"
            v-model="name"
            minlength="2"
            required
          >
          <label for="name">Namn</label>
        </fieldset>

        <fieldset>
          <input
            :class="hasData(phone)"
            name="phone"
            type="text"
            v-model="phone"
            minlength="8"
            ref="phone"
            required
          >
          <label for="phone">Telefonnummer</label>
        </fieldset>

        <fieldset class="button">
          <input
            :class="hasData(comment)"
            name="comment"
            type="text"
            v-model="comment"
          >
          <label for="comment">Ev. kommentar</label>
        </fieldset>
      </div>
      <ProgressButton text="Beställ" :callback="placeOrder" />
    </form>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import reportValidity from 'report-validity';
  import ModalMixin from 'mixins/modal';
  import ProgressButton from 'components/progress-button';
  import OrderModal from 'components/modals/order';
  import { get } from 'lodash';

  export default {
    components: { ProgressButton },
    mixins: [ModalMixin],
    data () {
      return {
        name: null,
        phone: null,
        email: null,
        comment: null
      };
    },
    modals: {
      OrderModal
    },
    computed: {
      ...mapState('order', ['selectedTimeSlot']),
      ...mapGetters('order', ['hasProductsInBasket', 'basket'])
    },

    mounted () {
      this.$store.commit('order/setCompleted', null);
    },

    methods: {
      hasData (field) {
        return { 'has-data': field && field.length };
      },

      async placeOrder (e) {
        this.$store.commit('order/setCompleted', null);

        if (this.phone) {
          this.phone = this.phone.replace(/\D/g, '');
        }

        const valid = reportValidity(this.$refs.form);

        if (!valid) {
          return;
        }

        const { name, phone, email, comment } = this;

        const orderData = {
          timeslot: this.selectedTimeSlot,
          customer: { name, phone, email, comment },
          items: this.basket
        };

        let error;
        let status;
        let response;

        try {
          this.$store.commit('order/setCompleted', { id: null });
          response = await this.$http.post('orders', orderData);
          error = get(response, 'data.error', null);
          status = response.status;
        } catch (e) {
          console.log(e);
          error = get(e, 'response.data.error', null) || 'unknown';
        }

        if (status !== 200) {
          this.$store.commit('order/setCompleted', null);
          this.openModal(this.$options.modals.OrderModal, { status, error });
          await this.$store.dispatch('order/loadTimeSlots');
        } else {
          this.$store.commit('order/setCompleted', response.data);
          this.$store.commit('order/clearBasket');
          this.$router.push({ name: 'location-order' });
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .order-details
    @extend .order-box
    display: flex
    flex-direction: column
    .inner
      padding: 0.1rem
      margin-bottom: 3rem
  h1
    @extend .t-orderHeader

  form
    display: flex
    flex-direction: column

  input
    line-height: 0
  input, textarea
    @extend .t-base
    width: 100%
    font-size: 16px
    padding: 1.2rem 1rem
    border: 0
    margin-bottom: 0
    -webkit-appearance: none

    position: relative

  fieldset
    position: relative

    &:not(.button):after
      content: ""
      position: absolute
      bottom: 0
      left: 0
      right: 0
      height: 1px
      background-image: repeating-linear-gradient(to right, black 0 6px, transparent 6px 9px)


  input::placeholder,
  label
    color: $black
    @extend .t-base
    text-transform: uppercase
    line-height: 0

  label
    position: absolute
    top: 50%
    left: 1.1rem
    transform: translate3d(0, 0, 0)
    transition: all 0.2s ease-in-out
    pointer-events: none

  fieldset input:focus + label,
  fieldset input.has-data + label,
  fieldset textarea:focus + label,
  fieldset textarea.has-data + label
    color: $grey-dark
    font-weight: 500
    font-size: .6rem
    transform: translate3d(0, -1.2rem, 0)

  textarea::placeholder
    color: $grey

  textarea
    resize: none
    margin-bottom: 2rem

  .order-button
    height: auto
    width: auto
</style>
